export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden">
              <div className="absolute -inset-1 bg-gradient-to-r from-primary-500/20 via-accent-500/20 to-primary-500/20 rounded-2xl blur-lg"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20theater%20interior%20atmosphere%20with%20soft%20golden%20red%20lighting%2C%20elegant%20premium%20streaming%20platform%20visual%2C%20luxurious%20home%20cinema%20vibe%2C%20comfortable%20viewing%20environment%2C%20no%20text%20no%20people%2C%20clean%20artistic%20composition&width=1000&height=700&seq=about-tianmei&orientation=landscape"
                alt="天美影视高清在线观影平台介绍"
                className="relative w-full h-auto object-cover rounded-2xl"
              />
            </div>
          </div>

          <div className="flex-1 order-1 lg:order-2 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">关于天美</h2>
            <div className="space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                天美影视成立于2023年，是一个专注于提供高清免费在线观影服务的综合影视平台。我们致力于为广大影视爱好者打造一个片源丰富、播放流畅、体验纯净的在线观影空间。
              </p>
              <p>
                平台汇聚超过20,000部高清电影、热播电视剧、综艺节目和动漫番剧，涵盖动作、喜剧、爱情、悬疑、科幻、古装等全类型题材。采用先进的视频编码和智能CDN加速技术，确保用户无论身处何地，都能享受不缓冲不卡顿的流畅观影体验。
              </p>
              <p>
                天美影视始终保持每日更新节奏，专业内容团队实时跟进最新片源，让用户第一时间观看到最新上线的影视作品。我们始终坚持以用户体验为核心，持续优化播放性能和界面设计，努力成为您最值得信赖的在线观影平台。
              </p>
            </div>
            <div className="mt-6 flex flex-wrap gap-6 justify-center lg:justify-start">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-500">500万+</div>
                <div className="text-xs text-foreground-500 mt-1">日活跃用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-500">20,000+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-secondary-500">99.9%</div>
                <div className="text-xs text-foreground-500 mt-1">服务稳定性</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}